/** ! WARNING: DO NOT EDIT ! **
  This file is generated by graphql codegen.
  Make changes to *.graphql documents, not this file
**/
import type * as _Types from '_gql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetApplicationDecisions_decisions_Decision = { readonly __typename: 'Decision', readonly id: string, readonly approvedAmountInCents: number, readonly maxApprovedAmountInCents: number | null, readonly offerType: _Types.UnderwritingOffer };

export type GetApplicationDecisions_Query = { readonly __typename: 'Query', readonly underwritingDeclined: boolean | null, readonly frozenAuthorizedSigner: boolean | null, readonly decisions: ReadonlyArray<GetApplicationDecisions_decisions_Decision | null> | null };


export type GetApplicationDecisionsVariables = _Types.Exact<{
  companyId: _Types.Scalars['String']['input'];
}>;


export type GetApplicationDecisions = GetApplicationDecisions_Query;


export const GetApplicationDecisionsDocument = gql`
    query GetApplicationDecisions($companyId: String!) {
  underwritingDeclined(companyId: $companyId)
  frozenAuthorizedSigner(companyId: $companyId)
  decisions(companyId: $companyId) {
    id
    approvedAmountInCents
    maxApprovedAmountInCents
    offerType
  }
}
    `;

/**
 * __useGetApplicationDecisions__
 *
 * To run a query within a React component, call `useGetApplicationDecisions` and pass it any options that fit your needs.
 * When your component renders, `useGetApplicationDecisions` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetApplicationDecisions({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useGetApplicationDecisions(baseOptions: Apollo.QueryHookOptions<GetApplicationDecisions, GetApplicationDecisionsVariables> & ({ variables: GetApplicationDecisionsVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetApplicationDecisions, GetApplicationDecisionsVariables>(GetApplicationDecisionsDocument, options);
      }
export function useGetApplicationDecisionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetApplicationDecisions, GetApplicationDecisionsVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetApplicationDecisions, GetApplicationDecisionsVariables>(GetApplicationDecisionsDocument, options);
        }
export function useGetApplicationDecisionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetApplicationDecisions, GetApplicationDecisionsVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetApplicationDecisions, GetApplicationDecisionsVariables>(GetApplicationDecisionsDocument, options);
        }
export type GetApplicationDecisionsHookResult = ReturnType<typeof useGetApplicationDecisions>;
export type GetApplicationDecisionsLazyQueryHookResult = ReturnType<typeof useGetApplicationDecisionsLazyQuery>;
export type GetApplicationDecisionsSuspenseQueryHookResult = ReturnType<typeof useGetApplicationDecisionsSuspenseQuery>;
export type GetApplicationDecisionsQueryResult = Apollo.QueryResult<GetApplicationDecisions, GetApplicationDecisionsVariables>;